import { callBackendFunction } from './renderCallable';

const callCentralFunction = async (name, payload = {}) => {
  return callBackendFunction({
    baseUrl: process.env.REACT_APP_CCS_BACKEND_URL,
    name,
    payload,
  });
};

export const centralAdminApi = {
  getDashboard: () => callCentralFunction('tmGetDashboard'),
  listTenants: () => callCentralFunction('tmListTenants'),
  refreshTenants: () => callCentralFunction('tmRefreshTenants'),
  getTenantSnapshot: (payload) => callCentralFunction('tmGetTenantSnapshot', payload),
  createTenant: (payload) => callCentralFunction('tmCreateTenant', payload),
  updateTenant: (payload) => callCentralFunction('tmUpdateTenant', payload),
  updateTenantStatus: (payload) => callCentralFunction('tmUpdateTenantStatus', payload),
  addAdminToTenant: (payload) => callCentralFunction('tmAddAdminToTenant', payload),
  replaceTenantAdmin: (payload) => callCentralFunction('tmReplaceTenantAdmin', payload),
  updateTenantBillingStatus: (payload) => callCentralFunction('tmUpdateTenantBillingStatus', payload),
  assignPlanToTenant: (payload) => callCentralFunction('tmAssignPlanToTenant', payload),
  addCreditsToTenant: (payload) => callCentralFunction('tmAddCreditsToTenant', payload),
  manualDeductCreditsFromTenant: (payload) => callCentralFunction('tmManualDeductCreditsFromTenant', payload),
  updateTenantUserLimit: (payload) => callCentralFunction('tmUpdateTenantUserLimit', payload),
  updateTenantAllowedApps: (payload) => callCentralFunction('tmUpdateTenantAllowedApps', payload),

  listPricingPlans: () => callCentralFunction('tmListPricingPlans'),
  createPricingPlan: (payload) => callCentralFunction('tmCreatePricingPlan', payload),
  updatePricingPlan: (payload) => callCentralFunction('tmUpdatePricingPlan', payload),
  setPricingPlanStatus: (payload) => callCentralFunction('tmActivateDeactivatePricingPlan', payload),

  listApps: () => callCentralFunction('tmListApps'),
  createApp: (payload) => callCentralFunction('tmCreateApp', payload),
  updateApp: (payload) => callCentralFunction('tmUpdateApp', payload),
  setAppStatus: (payload) => callCentralFunction('tmActivateDeactivateApp', payload),

  listCreditUsage: (payload) => callCentralFunction('tmListCreditUsage', payload),
  listAuditLogs: (payload) => callCentralFunction('tmListAuditLogs', payload),

  listApiClients: () => callCentralFunction('tmListApiClients'),
  createApiClient: (payload) => callCentralFunction('tmCreateApiClient', payload),
  revokeApiClient: (payload) => callCentralFunction('tmRevokeApiClient', payload),
};
